var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useField } from "@madmedical/form";
import FormControlWrapper from "../molecules/Form/FormControlWrapper";
import DateInput from "../molecules/Form/DateInput";
const FormDateInput = (_a) => {
    var { name, isRequired, hint, label, labelProps } = _a, rest = __rest(_a, ["name", "isRequired", "hint", "label", "labelProps"]);
    const { control, isError, error } = useField(name);
    return (_jsx(Controller, { name: name, control: control, rules: { required: isRequired }, render: ({ field: { onChange, value } }) => (_jsx(FormControlWrapper, Object.assign({ isInvalid: isError, isRequired: isRequired, error: error, hint: hint, label: label, labelProps: labelProps }, { children: _jsx(DateInput, Object.assign({}, rest, { onChange: (value) => {
                    onChange(value.toISOString());
                }, value: value ? new Date(value) : undefined })) }))) }));
};
export default FormDateInput;
